import { useAuthentication } from '@/hooks/useAuthentication';
import { useSuspenseQuery } from '@apollo/client';
import { type HomePageQuery, type HomePageQueryVariables, QUERY_HOME_PAGE } from '@edwin-group/cj-graphql';
import { useMemo } from 'react';

export const useHome = () => {
  const { authentication } = useAuthentication();
  const { data: homePage } = useSuspenseQuery<HomePageQuery, HomePageQueryVariables>(QUERY_HOME_PAGE, {
    fetchPolicy: 'cache-first',
  });

  const hasResourceHubAccess = useMemo(
    () => authentication?.user?.school?.subscription?.resourceHub || false,
    [authentication?.user?.school?.subscription?.resourceHub],
  );

  const hasMissionAccess = useMemo(
    () => authentication?.user?.school?.subscription?.mission || false,
    [authentication?.user?.school?.subscription?.mission],
  );

  return {
    homePage,
    hasResourceHubAccess,
    hasMissionAccess,
  };
};
